<template>
    <div class="parent-container">
        <div class="content-container" v-if="showMode==='list'">
            <div class="topic-sign-title">课题管理</div>
            <div class="topic-sign-name">（{{topicInfo.topicName}}）</div>
            <div class="line-item"></div>
            <div class="mode-container">
<!--                <div :class="activeModel==='1'?'model-item active':'model-item'" @click="changeModel('1')">子课题管理</div>-->
                <div :class="activeModel==='2'?'model-item active':'model-item'" @click="changeModel('2')">子课题审核</div>
            </div>
            <el-form v-if="activeModel==='1'" :model="queryParams" ref="queryForm" :inline="true">
                <el-row class="mt10">
                    <el-col :span="6" class="mb0" style="height: 30px;">
                        <el-form-item label="课题状态">
                            <el-select  clearable @change="getPageTopic()" v-model="queryParams.status" placeholder="请选择">
                                <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                           :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <!--子课题审核-->
            <div class="bre9e mt15" v-if="activeModel==='2'">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 260px)"
                          :data="dataList"
                          highlight-current-row>
                    <el-table-column type="index" fixed="left" align="center" label="序号" width="60" />
                    <el-table-column width="130" align="center" label="报名时间" prop="status">
                        <template #default="scope">
                            <div>
                                {{ timestampToTime(scope.row.createTime) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="200" align="center" label="子课题名称" prop="topicName">
                        <template #default="scope">
                            <div :title="scope.row.topicName" style="color: #409efe;" class="text-one cursor">
                                {{ scope.row.topicName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" label="教师姓名" prop="leaderNames">
                    </el-table-column>
                    <el-table-column width="200" align="center" label="所属单位" prop="orgName">
                    </el-table-column>
                    <el-table-column width="100" align="center" label="学段学科">
                        <template #default="scope">
                            <el-text>
                                {{scope.row.periodName?scope.row.periodName:'--'}}•{{scope.row.subjectName?scope.row.subjectName:'--'}}
                            </el-text>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" label="最高学历" prop="qualificationName">
                    </el-table-column>
                    <el-table-column width="100" align="center" label="技术职称" prop="rankLevelName">
                    </el-table-column>
                    <el-table-column width="80" fixed="right" align="center" label="审核专家" prop="checkUserName">
                    </el-table-column>
                    <el-table-column width="80" fixed="right" align="center" label="审核状态" prop="isCheck">
                        <template #default="scope">
                            <div v-if="scope.row.isCheck===1" class="tab-dfp">待分配</div>
                            <div v-if="scope.row.isCheck===2" class="tab-dsh">待审核</div>
                            <div v-if="scope.row.isCheck===3" class="tab-shtg">通过</div>
                            <div v-if="scope.row.isCheck===4" class="tab-shjj">拒绝</div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" width="160" label="操作" align="center"
                                     class-name="small-padding fixed-width">
                        <template #default="scope">
                            <el-button type="primary"
                                       style="background-color: #3b82f6;color: #fff"
                                       size="small"
                                       :disabled="scope.row.isCheck!==1&&scope.row.isCheck!==2"
                                       @click="topicFp(scope.row)">
                                分配
                            </el-button>
                            <el-button type="primary" size="small"  @click="topicCheck(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="zdyfy">
                <pagination class="zdyfy" :background="false" :pageSizes="[10, 20, 30]" :total="total"
                            :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getPageTopic" />
            </div>
        </div>

        <!-- 子课题审核查看 -->
        <div class="detail-mode" v-if="showMode==='subtopic'">
            <sub-topic-check :sub-topic-id="subTopicId" @change-active-mode="changeActiveModel"/>
        </div>

        <el-dialog  v-model="isFpShow" width="640px" :show-close="false">
            <div class="topic-fp-title">审核分配</div>
            <el-card class="fp-container" :body-style="{padding: '10px 10px 10px 10px'}">
                <div class="check-top-container">
                    <div class="refresh-container" >
                        <div class="refresh-icon" @click="refreshCheckUser">
                            <img class="img-100" src="../../assets/refresh.png" alt="">
                        </div>
                        <div class="refresh-title" @click="refreshCheckUser">刷新列表</div>
                    </div>
                    <div class="search-container">
                        <el-input v-model="checkUserName" class="w-50 m-2"
                                  placeholder="按姓名搜索专家" :prefix-icon="Search"/>
                    </div>
                </div>
                <el-scrollbar class="fp-scrollbar" >
                    <div v-for="item in filterCheckUser" class="check-user-item">
                        <div class="sel-container" @click="selCheckUser(item.userId)">
                            <div class="check-icon-container">
                                <img class="img-100" v-if="checkUserId!==item.userId" src="../../assets/img/uncheck.png" alt="">
                                <img class="img-100" v-if="checkUserId===item.userId" src="../../assets/img/checked.png" alt="">
                            </div>
                            <div class="check-icon-word">
                                分配
                            </div>
                        </div>
                        <div class="sel-user-container">
                            <div class="user-check-data">
                                <div class="data-user">{{item.trueName}}</div>
                                <div class="data-item">已分配：{{item.fpCount}}</div>
                                <div class="data-item">已评估：{{item.shCount}}</div>
                            </div>
                            <div class="user-check-pro">
                                <el-progress :percentage="item.rateCount" />
                            </div>
                        </div>
                    </div>
                </el-scrollbar>
            </el-card>

            <div class="fp-btn-container">
                <el-button type="primary" style="margin: auto" @click="submitCheckInfo">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { serviceUrl } from "@/utils/global"
import { infoTopic,checkUserList } from "@/api/admin/topic"
import { subpageTopic ,checkUserTopic} from "@/api/admin/lead"
import {timestampToTime} from "@/utils/date";
import {Search} from "@element-plus/icons";
import subTopicCheck from "@/components/homeManager/subTopicCheck.vue";
export default {
    name: "topicManagerInfo",
    components: {subTopicCheck},
    props:{
        topicId:{
            type: String,
            default:null,
        },
    },
    data() {
        return {
            listMode:'list',
            subTopicMode:'subtopic',
            showMode:'list',
            role:this.$storage.get("role") ,
            userId:JSON.parse(this.$storage.get("userInfo")).userId,
            serviceUrl,
            timestampToTime,
            parentTopicId:'',
            topicInfo:{},
            total: 0,
            pageCount:0,
            dataList: [],
            activeModel:'2',
            isFpShow:false,
            checkUserId:"",
            statusList:[
                { name: '初始阶段', value: 0 },
                { name: '报名阶段', value: 1 },
                { name: '中期检查', value: 2 },
                { name: '开题论证', value: 3 },
                { name: '结题验收', value: 4 },
                { name: '课题结束', value: 5 },
            ],
            queryParams: {
                topicName: '',
                parentTopicId: '',
                isCheck: '',
                status: '',
                pageNum: 1,
                pageSize: 10,
            },
            checkUserName:'',
            checkUserList:[],
            checkForm:{
                topicId:'',
                userId:'',
            },
            subTopicId:'',
        };
    },
    created() {

    },
    mounted() {
        this.parentTopicId = this.topicId
        this.queryParams.parentTopicId = this.topicId
        this.getTopicInfo()
        this.getPageTopic()
    },
    unmounted() {},
    computed: {
        Search() {
            return Search
        },
        filterCheckUser(){
            if (this.checkUserName=== ''){
                return this.checkUserList;
            }
            return this.checkUserList.filter((item)=>{
                return item.trueName.includes(this.checkUserName)
            })
        }
    },
    methods: {
        getTopicInfo() {
            infoTopic({ topicId: this.parentTopicId }).then(res => {
                if (res.data.code === 1) {
                    this.topicInfo = res.data.data;
                    this.checkUserList = this.topicInfo.checkUserList;
                }else {
                    this.$message.error("请求出错")
                }

            })
        },
        refreshCheckUser(){
            checkUserList({ topicId: this.parentTopicId }).then(res => {
                if (res.data.code === 1) {
                    this.checkUserList = res.data.data;
                    this.$message.success("刷新成功")
                }else {
                    this.$message.error("请求出错")
                }

            })
        },
        changeModel(activeItem){
            this.activeModel = activeItem
            if (activeItem==='1'){
                this.queryParams.isCheck = 3
            }else {
                this.queryParams.isCheck = ''
            }
            this.getPageTopic()
        },
        getPageTopic(e){
            this.dataList = []
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            subpageTopic(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.dataList = res.data.data.list;
                    this.total = res.data.data.total;
                    this.pageCount = res.data.data.totalPage;
                }else{
                    this.$message.error("请求出错")
                }
            })
        },
        topicFp(row){
            this.checkForm.topicId = row.topicId;
            this.checkUserId = ""
            this.checkForm.userId = ""
            if (row.checkUser){
                this.checkUserId = row.checkUser
                this.checkForm.userId = row.checkUser
            }
            this.isFpShow = true;
        },
        selCheckUser(userId){
            this.checkUserId = userId;
            this.checkForm.userId = userId;
        },
        submitCheckInfo(){
            if(this.checkForm.userId===''||
              this.checkForm.userId===null
              || this.checkForm.userId===undefined){
                this.$message.error("请选择审核人")
                return;
            }

            checkUserTopic(this.checkForm).then(res => {
                if (res.data.code === 1) {
                    this.getPageTopic()
                    this.refreshCheckUser()
                    this.isFpShow = false;
                }else{
                    this.$message.error("请求出错")
                }
            })
        },
        topicCheck(row){
            this.subTopicId = row.topicId;
            this.showMode = this.subTopicMode;
        },
        subTopicManager(row){
            this.$router.push({
                path: "/subTopicManager",
                query: {
                    topicId: row.topicId,
                }
            });
        },
        changeActiveModel(model,activeItem){
            this.showMode = model;
            this.getPageTopic()
        }
    }
};
</script>
<style scoped>
.parent-container{
    height: 100%;
    width: 100%;
}
.content-container{
    height: 100%;
    width: 100%;
    background-color: #fff;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.topic-sign-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    color: #ff7f2e;
    margin-top: 5px;
    text-align: center;
}
.topic-sign-name{
    width: 100%;
    height: 30px;
    font-size: 15px;
    color: #333333;
    text-align: center;
}
.line-item{
    width: 100%;
    height: 1px;
    background-color: #ff7f2e;
    margin: auto;
}
.mode-container{
    width: 100%;
    height: 20px;
    display: flex;
    border-left: 3px solid #ff7f2e;
    margin-top: 10px;
    padding-left: 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.model-item{
    width: auto;
    padding-right: 10px;
    line-height: 20px;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
}
.active{
    color: #ff7f2e;
}
/deep/ .el-select__wrapper{
    min-height: 28px;
}
.tab-dfp{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #ffbf6b
}
.tab-dsh{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #4095e5
}
.tab-shtg{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #81b337;
}
.tab-shjj{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #bd3124;
}
/deep/ .el-dialog__header{
    padding-bottom: 0!important;
}
.topic-fp-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    color: #ff7f2e;
    text-align: center;
}
.fp-container{
    width: 90%;
    height: 400px;
    margin: auto;
    border-radius: 10px;
}
.fp-btn-container{
    padding-top: 10px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;
}
/deep/ .el-input-group__prepend {
    background: var(--el-color-primary);
    color: #fff;
}
.check-top-container{
    width: 100%;
    height: 40px;
    border-bottom: 2px solid #ccc;
    display: flex;
}
.refresh-container{
    width: 60%;
    height: 40px;
    display: flex;
    cursor: pointer;
}
.refresh-icon{
    width: 22px;
    height: 22px;
    margin-top: 9px;
    margin-left: 20px;
}
.refresh-title{
    width: auto;
    height: 30px;
    line-height: 30px;
    color: #000000;
    margin-top: 5px;
}
.search-container{
    width: 40%;
    height: 26px;
}
.fp-scrollbar{
    width: 100%;
    height: 400px;
    margin-top: 6px;
}
.check-user-item{
    width: 100%;
    height: 70px;
    display: flex;
}
.sel-container{
    width: 80px;
    height: 70px;
    display: flex;
    padding-left: 20px;
    box-sizing: border-box;
    cursor: pointer;
}
.check-icon-container{
    width: 18px;
    height: 18px;
    margin-top: 26px;
}
.check-icon-word{
    height: 70px;
    line-height: 70px;
}
.sel-user-container{
    width: calc(100% - 100px);
    height: 60px;
    border-radius: 10px;
    border: 1px solid #ccc;
    margin-top: 4px;
    padding:0 10px 0 10px;
    box-sizing: border-box;
}
.user-check-data{
    width: 100%;
    height: 35px;
    display: flex;
    padding-top: 5px;
    box-sizing: border-box;
}
.data-user{
    width: calc(100% - 160px);
    height: 35px;
    padding-top: 5px;
    box-sizing: border-box;
    color: #333333;
    font-weight: bold;
    font-size: 14px;
}
.data-item{
    width: 80px;
    height: 35px;
    padding-top: 5px;
    box-sizing: border-box;
    color: #999999;
    text-align: right;
}
.user-check-pro{
    width: 100%;
    height: 20px;
}
</style>